<template>
    <div class="feedback-wrapper">
        <div class="feedback" @click="show">
            <div class="icon icon-p-phone"></div>
        </div>
        <div class="feedback-dialog-wrapper" v-show="fd_show">            
            <div class="feedback-dialog">
                <i class="icon icon-close" @click="close"></i>
                <h2 class="fd-title">FeedBack</h2>
                <div class="form-element">
                    <textarea name="" id="" cols="30" rows="10" @input="tinput" v-model="content" placeholder="Please fill in the questions and comments you encounter, we will try to do better"></textarea>
                    <div class="number-limit" v-text="`${content.length} / 300`"></div>
                </div>
                <div class="service">
                    Email: <span v-text="mail"></span> <br>
                    Phone: <span v-text="phone"></span>
                </div>
                <div class="btn-group">
                    <button type="button" class='fd-button' @click="submit">Submit</button>
                </div>
            </div>
        </div>        
    </div>        
</template>
<script>
import { feedback,getConfig } from "@api/index";
export default {
    data () {
        return {
            content:'',
            fd_show:false,
            clicked:false,
            phone:"",
            mail:""
        }
    },
    mounted () {
        getConfig().then((res)=>{
            if(res.code == 0) {
                this.phone = res.data.customer.phone
                this.mail = res.data.customer.email
            }
        })
    },
    methods:{
        submit () {
            if(this.clicked)return 
            this.clicked = true
            if(this.content.length == 0)return
            let formData = new FormData()
            formData.append('content', this.content)
            feedback(formData).then(resp => {
                if(resp.code == 0) {
                    this.close()                    
                }
                this.content = ""
                this.clicked = false
            })
        },
        tinput () {
            let reg = /[^A-Za-z0-9_?!,. ]+/
            if(this.content.length > 300) {
                this.content = this.content.substring(0, this.content.length - 1)
            }
            if(reg.test(this.content)) {
                this.content = this.content.substring(0, this.content.length - 1)
            }
        },
        close () {
            this.fd_show = false
        },
        show () {
            this.fd_show = true
        }
    }
}
</script>
<style lang="less" scoped>
@import "~assets/less/icon.less";
    .service{
        text-align: center;
        font-size: 32px;
        color:#999;
        line-height:1.5;
        margin-top: 20px;
    }
    .feedback-wrapper{
        .feedback{
            position: fixed;
            bottom:200px;
            right:0;
            width:100px;
            height: 70px;
            border-radius: 50px 0 0 50px;
            background:#f3dec6;
            padding-top: 30px;
            z-index: 10;
        }
        
    }
    .feedback-dialog-wrapper{
        width: 100%;
        height: 100%;
        left:0;
        top:0;
        right:0;
        bottom:0;
        background:rgba(0,0,0,0.7);
        position: fixed;
        z-index: 100;
        .icon{
            position:absolute;
            top:10px;
            right:10px;
        }
    }
    .feedback-dialog{
        position: absolute;
        width: 630px;
        height: 600px;
        background:#fff;
        left:50%;
        top:50%;
        transform: translate(-50%,-50%);
        padding:30px;
        border-radius: 20px;
        .fd-title{
            text-align:center;
            font-size: 42px;
            font-weight: 700;
            color:#be9060;
        }
        .form-element{
            border:2px solid #be9060;
            padding:20px;
            height:200px;
            margin-top: 50px;
            .number-limit{
                height:30px;
                font-size: 24px;
                float:right;
                margin-top: 10px;
                color:#999;
            }
            textarea{
                border:none;
                font-size: 24px;
                width: 100%;
                height: 170px;
                display: block;
                resize:none;
                word-break: break-all;
                &:focus-visible{
                    outline: none;
                }
            }
        }
        .btn-group{
            width: 500px;
            margin:50px auto;
            .fd-button{
                display:block;
                width: 500px;
                height: 96px;
                background: #be9060;
                border:none;
                border-radius: 12px;
                color: #FFFFFF;
                text-align: center;
                line-height: 96px;
                font-size: 32px;
                margin:0 auto;
            }
        }
        
    
    }
</style>